import { render } from "./ChangeEmailPhonePage.vue?vue&type=template&id=fb7da6be"
import script from "./ChangeEmailPhonePage.vue?vue&type=script&lang=js"
export * from "./ChangeEmailPhonePage.vue?vue&type=script&lang=js"
script.render = render

export default script